<template>
  <div v-if="total > 1" class="pagination">
    <button class="pagination__prev" :class="{ 'no-hover': pagination.page === 1 }" :disabled="pagination.page === 1" @click="prevPagiPage">
      <i class="icon icon-arrow-left"></i>
    </button>

    <button class="pagination__page" v-if="total > 1" :class="{ active: pagination.page === 1 }" @click="pagination.page = 1">
      <p class="typo-button14 typo-medium">1</p>
    </button>
    <button class="pagination__page" disabled v-if="pagination.page > 4 && pagiRange.min > 2">
      <p class="typo-button14 typo-medium">...</p>
    </button>
    <div class="inner-pagi">
      <button class="pagination__page" :class="{ active: pagination.page === i + pagiRange.min - 1 }" v-for="i in pagiRange.left + 1" :key="i + pagiRange.min - 1" @click="pagination.page = i + pagiRange.min - 1">
        <p class="typo-button14 typo-medium">{{ i + pagiRange.min - 1 }}</p>
      </button>
    </div>
    <div class="inner-pagi" v-if="pagiRange.right + 1 > 0">
      <button class="pagination__page" :class="{ active: pagination.page === i + pagination.page }" v-for="i in pagiRange.right + 1" @click="pagination.page = i + pagination.page" :key="i + pagination.page">
        <p class="typo-button14 typo-medium">{{ i + pagination.page }}</p>
      </button>
    </div>
    <button class="pagination__page" disabled v-if="pagination.page < total - 3 && pagiRange.max < total - 1">
      <p class="typo-button14 typo-medium">...</p>
    </button>
    <button class="pagination__page" :class="{ active: pagination.page === total }" @click="pagination.page = total" v-if="pagiRange.max < total">
      <p class="typo-button14 typo-medium">{{ total }}</p>
    </button>

    <button class="pagination__next" @click="nextPagiPage" :class="{ 'no-hover': pagination.page === total }" :disabled="pagination.page === total">
      <i class="icon icon-arrow-right"></i>
    </button>
  </div>
</template>

<script>
/**
 * Calculate deps for pagination.
 * @param {Number} _c current index
 * @param {Number} total total page count
 * @param {Number} bound number of item left/right side of pagination.
 */
function calcPagi(_c, total, bound) {
  if (_c) {
    let _r = {
      min: _c - bound,
      max: _c + bound
    };

    if (_r.min <= 1) {
      let change = 2 - _r.min;
      _r.min = 2;
      if (_r.max + change <= total) _r.max += change;
    }

    if (_r.max > total) {
      let change = _r.max - total;
      _r.max = total;
      if (_r.min - change > 1) _r.min -= change;
    }

    _r.left = _c - _r.min;
    _r.right = _r.max - _c - 1;
    return _r;
  } else {
    return {
      left: 0,
      right: 0,
      min: 1,
      max: 1
    };
  }
}

export default {
  name: "Pagination",
  props: {
    total: Number,
    paginationParam: Object
  },
  data() {
    return {
      pagination: { per: 10, page: 1 },
      windowWidth: window.outerWidth
    };
  },
  computed: {
    pagiRange() {
      let _c = this.pagination.page;
      if (this.windowWidth > 800) {
        return calcPagi(_c, this.total, 2);
      } else {
        return calcPagi(_c, this.total, 1);
      }
    }
  },
  watch: {
    "pagination.page"(newVal, oldVal) {
      // window.scrollTo(0, 0);
      if (newVal !== oldVal) this.$emit("page", newVal);
    },
    paginationParam: {
      deep: true,
      // immediate: true,
      handler(newVal) {
        this.pagination = { ...newVal };
      }
    }
  },
  beforeMount() {
    if (this.paginationParam) this.pagination = { ...this.paginationParam };
  },
  mounted() {
    const func = () => {
      this.windowWidth = window.outerWidth;
    };
    this.$nextTick(() => {
      window.addEventListener("resize", func);
    });
  },
  beforeDestroy() {
    const func = () => {
      this.windowWidth = window.outerWidth;
    };
    this.$nextTick(() => {
      window.removeEventListener("resize", func);
    });
  },
  methods: {
    nextPagiPage() {
      let _inc = this.pagination.page + 1;
      this.pagination.page = _inc >= this.total ? this.total : _inc;
    },
    prevPagiPage() {
      let _dec = this.pagination.page - 1;
      this.pagination.page = _dec <= 1 ? 1 : _dec;
    }
  }
};
</script>

<style lang="scss" scoped>
.pagination {
  @include flex-center;
  font-size: 14px;
  letter-spacing: 0.2px;
  width: 100%;
  margin-top: 30px;
  // margin-bottom: 30px;

  // background-color: #ffffff;

  .inner-pagi {
    flex-direction: row;
    display: flex;
  }

  button {
    @include flex-center;
    @include trans-all;
    box-shadow: none;
    border: none;
    min-width: 32px;
    height: 32px;
    margin: 0 4px;
    color: $textLightModeLow;
    background-color: transparent;
    font-weight: 500;
    font-size: 14px;
    line-height: 1em;
    border-radius: $radius;
    outline: none;

    &:not([disabled]):hover {
      color: $textLightModeHigh;
      background: $light1;
      cursor: pointer;
    }

    &[disabled] {
      opacity: 0.3;
    }
  }

  &__page {
    border-bottom: 2px solid transparent;

    &.active {
      color: $cPrimary;
    }

    &-disabled {
      cursor: default;
    }
  }
}
</style>
